<script lang="ts">
    export let direction = "right";
    export let isPaused = false;
    export let rootElement;
    let flipsvg = false;

    if (direction == "left") {
      flipsvg = true;
    }
</script>

<style lang="scss">
  * {
    .shapes > * {
    opacity: 0;
    animation-duration: 1.5s;
    animation-iteration-count: infinite; 
    animation-timing-function: steps(1);
  }
  .paused .shapes > * {
    filter: grayscale(100%);
      opacity: 0.8;
      animation-play-state: paused;
    }
  
  .flip .shapes > *{
    transform-origin: center center;
    transform: scaleX(-1); }

  @keyframes crunch-1 {
    0% {
      opacity: 1;
    }
    50%,
    100% {
      opacity: 0;
    }
  }
  #crunch-1 {
    animation-name: crunch-1;
  }
  @keyframes crunch-2 {
    0% {
      opacity: 0;
    }
    50%,
    100% {
      opacity: 1;
    }
  }
  #crunch-2 {
    animation-name: crunch-2;
  }

 
  }
</style>

<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300.5 111.4" height="100%" width="100%">
<g class:paused={isPaused} class:flip={flipsvg}>
  <g class="shapes" bind:this={rootElement}>
  <g id="crunch-1">
    <path
      fill="var(--flesh)"
      d="m193 20 2-2 18-15 6-3h3l5 4h2c4-1 8 1 10 5l5 5c2 3 2 7 2 11a45 45 0 0 0 3 14c3 6 4 13 5 20l3 11a4 4 0 0 0 1 3v1a57 57 0 0 0 3 8l1 3a3 3 0 0 0 0 4l1 1-3 4a7 7 0 0 1-11-5c0-2 0-4-2-4l-1-1a83 83 0 0 0-9-16c-1-1-2-2-4-1l-3-5-11-15a27 27 0 0 0-1 4c-2 8-6 15-12 21a12 12 0 0 0-1 1c-3 2-3 2-5-1a63 63 0 0 1-7-15c-1-7-3-13-2-20 0-4 1-8 4-10l1-2-3-5ZM0 91l6-8c2-3 5-4 8-5l4-2c6-1 12-1 17 1 0 3 3 2 4 2l2 1a6 6 0 0 1 2 0l14 7a2 2 0 0 1 2 3l-2 1c-2 0-5 0-5 3a1 1 0 0 1 0 1c-4 1-6 5-9 6a1 1 0 0 0-1 2l-19 2a34 34 0 0 1-13-2 6 6 0 0 1-4-2l-6-8Z"
    />
    <path
      fill="var(--shirt)"
      d="M42 103a1 1 0 0 1 1-2c3-1 5-5 9-6a1 1 0 0 0 0-1c0-3 3-3 5-3l2-1a2 2 0 0 0-2-3l-14-7a6 6 0 0 0-2 0l-2-1-2-1 2-1a34 34 0 0 0 8-1 11 11 0 0 0 3-1 97 97 0 0 0 15-12l10-10c6-6 13-8 20-8a163 163 0 0 1 22 0c5 0 8 3 12 4a68 68 0 0 0 9 4c3 0 6 1 8-2 1-2 3-2 5-2l5 2a4 4 0 0 1 0 2l-5 14a6 6 0 0 0 0 6 4 4 0 0 1 1 4c-3 5-2 10-2 15a2 2 0 0 0 1 2l5 2v1l-1 3a4 4 0 0 1-4 0 46 46 0 0 0-5-3c-3-2-6-2-9-2a247 247 0 0 0-35 0c-11 0-21 3-31 5l-18 2-11 1Z"
    />
    <path
      fill="var(--pants)"
      d="m156 96-5-2a2 2 0 0 1-1-2c0-5-1-10 2-15a4 4 0 0 0-1-4 6 6 0 0 1 0-6l5-14a4 4 0 0 0 0-3 3 3 0 0 1 2-1c5-1 10-4 14-7l7-8c3-5 8-9 12-13l2-1 3 5-1 2c-3 2-4 6-5 10 0 7 2 13 3 20a63 63 0 0 0 7 15c2 3 2 3 5 1a12 12 0 0 1 1-1v2c1 3 1 6-3 8l-20 10a50 50 0 0 1-27 4Z"
    />
    <path
      fill="var(--hair)"
      d="M233 67c2-1 3 0 4 1a83 83 0 0 1 9 16l1 1c2 0 2 2 2 4a7 7 0 0 0 11 5l3-4-1-1a3 3 0 0 1 0-4l-1-3a57 57 0 0 1-3-8v-1l12 4a18 18 0 0 1 5 2c2 1 2 3 1 5a9 9 0 0 1-6 2l-3 1 1 1c9 6 18 11 28 12a6 6 0 0 1 3 2 4 4 0 0 1-1 6c-2 2-5 2-8 2-12 2-25 1-37 0l-7-1a3 3 0 0 1-3-3 19 19 0 0 1 1-7 58 58 0 0 0 2-11c0-2 0-2-2-2a44 44 0 0 1-7 1 13 13 0 0 1-5 0c-2-1-3-2-2-5a44 44 0 0 0 2-7 5 5 0 0 0 0-3 5 5 0 0 1 1-5Z"
    />
    <path
      fill="var(--flesh)"
      d="M65 63a97 97 0 0 1-15 12 11 11 0 0 1-3 1 34 34 0 0 1-9 1l-1 1 2 1c-1 0-4 1-4-2h5a20 20 0 0 1-2-2c-1-1-2-3-1-5s2-2 3-2h3l2-1a3 3 0 0 0-1-3 5 5 0 0 0-1-1 21 21 0 0 1-7-2 5 5 0 0 0-5-1c-1 1-2-1-2-2a7 7 0 0 1 0-3 47 47 0 0 1 3-8h6l5 1h4l4-2c1 0 3 0 3 2l1 1c3 0 5 1 6 3l1 1c4 0 4 1 4 4l-1 6Z"
    />
    <path
      fill="var(--hair)"
      d="M32 47a47 47 0 0 0-3 8 7 7 0 0 0 0 3c0 1 1 3 2 2a5 5 0 0 1 5 1 21 21 0 0 0 7 2 5 5 0 0 1 1 1 3 3 0 0 1 1 3l-2 1h-3l-3 2 1 5a20 20 0 0 0 2 2h-5c-5-2-11-2-17-1a25 25 0 0 1 0-5l3-18 2-8c1-2 3-2 5-1 2 0 3 2 4 3Z"
    />
    <path fill="var(--flesh)" d="m39 79 2 1-2-1Z" />
  </g>
  <g id="crunch-2">
    <path
      fill="var(--hair)"
      d="M267 111a16 16 0 0 0-5 0l-16-2c-1 0-2-1-2-3-1-3 0-6 1-10a69 69 0 0 0 1-9l-1-1-7 1a11 11 0 0 1-6 0c-2-1-3-2-2-4a44 44 0 0 0 2-8 6 6 0 0 0 0-3 4 4 0 0 1 1-5h3c4 6 8 11 10 17l1 1c2 0 2 1 2 3a12 12 0 0 0 1 3 8 8 0 0 0 10 3l3-4c1-1-1-1-1-2v-2c1-2-1-4-1-6l-3-6v-1a69 69 0 0 0 16 6l2 1v3a11 11 0 0 1-7 4h-2a4 4 0 0 0 2 2c8 5 17 10 27 11a11 11 0 0 1 4 3v1c-3 4-7 6-12 6l-5 1h-13Z"
    />
    <path fill="var(--pants)" d="M270 111h12Z" />
    <path
      fill="var(--shirt)"
      d="M87 45c5 2 9 4 14 4a22 22 0 0 1 12 3c4 2 8 2 12 1a3 3 0 0 1 2-1l10 1c5 1 11 2 16-2h1a66 66 0 0 1-1 14c-1 6-2 12-1 18a11 11 0 0 1 0 7 27 27 0 0 0-2 12c0 3 0 3-2 2-7 0-13-2-19-1l-13 1a112 112 0 0 1-18-1l-11-1a32 32 0 0 1-14-4c-6-2-11-5-16-9a8 8 0 0 0-6-3c-3 0-3-2-4-4h7a5 5 0 0 0 4-3c3-5 1-10-1-15 0-2-2-4-4-6h3c2 0 2 1 3 2s2 1 3-1a9 9 0 0 1 3-2l9-3a20 20 0 0 0 7-2 12 12 0 0 0 5-6 1 1 0 0 1 1-1Z"
    />
    <path
      fill="var(--flesh)"
      d="M258 73v1l3 6c0 2 2 3 1 6v2s2 1 1 2l-3 4a8 8 0 0 1-10-3 12 12 0 0 1-1-3c0-2 0-3-2-3l-1-1c-2-6-6-12-10-17h-3l-5-8-7-10c-1-1-1-2-2 0l-5 13-2 1-2 4c-1 2-2 2-3 0-5-7-10-15-13-23v-2c4-2 6-5 4-10 0-4-2-8-7-10l2-2 20-17a13 13 0 0 1 4-2c4-1 7-1 9 2a3 3 0 0 0 4 1c4-1 7 1 9 3a81 81 0 0 1 5 8 13 13 0 0 1 2 7 49 49 0 0 0 4 19c2 3 2 7 3 11l4 18a5 5 0 0 0 1 3Z"
    />
    <path
      fill="var(--pants)"
      d="M191 22c5 2 7 6 7 10a1 1 0 0 0 0 1c2 4 0 7-4 9v2c3 8 8 16 13 23 1 2 2 2 3 0l2-4 2-1a69 69 0 0 1 1 11c0 3-1 4-4 5a23 23 0 0 0-13 9c-6 10-16 13-27 15a90 90 0 0 1-14 1l-7-1a27 27 0 0 1 2-12 11 11 0 0 0 0-7c-1-6 0-12 1-18a66 66 0 0 0 1-14l11-2a3 3 0 0 0 2-1c0-1 1-2 2-1s1 0 1-1l3-6c3-6 8-11 13-15 2-1 3-3 5-3Z"
    />
    <path
      fill="var(--flesh)"
      d="m53 58 4 6c2 5 4 10 1 15a5 5 0 0 1-4 3h-7l-7-3-17-8a8 8 0 0 1-4-5l-2-9a8 8 0 0 1 4-7l9-5a7 7 0 0 0 2-2 4 4 0 0 1 4-1c4 0 6 2 9 4a10 10 0 0 1 5 9 2 2 0 0 0 1 1 20 20 0 0 1 2 2Z"
    />
    <path
      fill="var(--flesh)"
      d="M87 45a1 1 0 0 0-1 1 12 12 0 0 1-5 6 20 20 0 0 1-7 2l-9 3a9 9 0 0 0-3 2c-1 2-2 2-3 1l-2-2-1-1 3-4 1-1-5-4a5 5 0 0 1-3-5c1-3 3-5 6-3l3 2c2 1 2 0 3-1a2 2 0 0 0 0-3 24 24 0 0 1-5-7 5 5 0 0 0-2-3c-2-1-3-2-1-4a30 30 0 0 1 7-5h1l6 4a4 4 0 0 1 2 1c1 4 4 4 7 5 3 0 3 1 2 3l1 2c2 1 3 3 3 5a3 3 0 0 0 1 3 5 5 0 0 1 1 3Z"
    />
    <path
      fill="var(--hair)"
      d="M64 19h-1a30 30 0 0 0-7 5c-2 2-1 3 1 4a5 5 0 0 1 2 3 24 24 0 0 0 5 7 2 2 0 0 1 0 3c-1 1-1 2-3 1l-3-2c-3-2-5 0-6 3a5 5 0 0 0 3 5l5 4-1 2-3 3a3 3 0 0 1-3-1 27 27 0 0 0-3-1 10 10 0 0 0-5-9c-3-2-5-4-9-4-2-6 0-10 4-14l12-11 7-5c1-2 3-1 4 1a12 12 0 0 1 1 6Z"
    />
  </g>
</g>
</g>
    {#if isPaused}
    <svg viewBox="-6 -5 36 36" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M10 24h-6v-24h6v24zm10 0h-6v-24h6v24zm-11-23h-4v22h4v-22zm10 0h-4v22h4v-22z"/></svg>
    {/if} 
  </svg>